import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'maschinenakte',
  title: 'Digitale Maschinenakte',
  description: 'Maschinen, Bilder und technische Unterlagen an einem Ort.',
  icon: 'FolderOpen',
  order: 110,
  apiBasePath: '/api/maschinenakte',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  // Leeres Array: für alle angemeldeten Nutzer sichtbar.
  // Sobald hier eine Rolle steht, sehen nur Nutzer mit dieser Rolle das Modul.
  roles: ['platform.admin', 'maschinenakte.admin', 'maschinenakte.nutzer'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
